import React from 'react';
export const ExtendedTestimonialsSection = ({
  isInitial = false
}: {
  isInitial?: boolean;
}) => {
  const initialTestimonials = [{
    initials: 'MP',
    name: 'Marta R.',
    city: 'Buenos Aires',
    desc: 'Hija y cuidadora familiar · Adulta mayor con deterioro cognitivo leve · Buenos Aires',
    quote: 'Mi mamá tiene 78 años y empezaba con olvidos frecuentes. No sabía cómo ayudarla sin que se pusiera triste. Con el Cuaderno Mente Despierta ahora compartimos una hora de actividades todas las tardes. Es el primer material que ella disfruta y que yo entiendo. Su neurólogo notó la diferencia en la primera consulta.'
  }, {
    initials: 'RC',
    name: 'Ricardo G.',
    city: 'Córdoba',
    desc: 'Cuidador profesional a domicilio · Córdoba Capital',
    quote: 'Soy enfermero a domicilio y el Módulo vip de +150 ejercicios, cambió completamente mi forma de trabajar. Tengo actividades físicas y cognitivas organizadas por niveles para cada paciente. Los familiares están felices porque ven un plan profesional y organizado. Ya no improviso nada.'
  }, {
    initials: 'SL',
    name: 'Silvina M.',
    city: 'Rosario',
    desc: 'Hija a cargo · Adulto mayor con diabetes e hipertensión · Rosario',
    quote: 'El Bono Cocina Vital me salvó. Mi papá es hipertenso y diabético y ya no sabía qué cocinarle que sea rico y seguro. Las recetas son simples, con ingredientes del súper de la esquina. Bajó su inflamación, mejoró su ánimo y yo dejé de sentirme culpable a la hora de comer.'
  }];
  const extendedTestimonials = [...initialTestimonials, {
    initials: 'GP',
    name: 'Gabriela P.',
    city: 'Mendoza',
    desc: 'Nuera y cuidadora · Adulta mayor con Parkinson · Mendoza',
    quote: 'El Protocolo Cuidado Experto es exactamente lo que necesitaba para cuidar a mi suegra con Parkinson. Antes no sabía qué hacer cuando tenía episodios de rigidez. Ahora tengo un protocolo claro y sé exactamente cuándo llamar al médico. Me devolvió la calma.'
  }, {
    initials: 'LF',
    name: 'Laura F.',
    city: 'La Plata',
    desc: 'Hija y cuidadora · Adulto mayor hipertenso · La Plata',
    quote: 'La Bitácora de Control 360 organizó todo lo que antes eran papelitos sueltos. Ahora llevo el registro completo de presión, glucemia y medicación al médico de mi papá. El cardiólogo me dijo que es el paciente mejor controlado que tiene. Y yo duermo mejor sabiendo que tengo todo bajo control.'
  }, {
    initials: 'JR',
    name: 'Javier R.',
    city: 'Tucumán',
    desc: 'Nieto y cuidador familiar · Adulto mayor 82 años · Tucumán',
    quote: 'Nunca imaginé que iba a poder hacer ejercicio con mi abuelo. La Guía Movilidad Sin Miedo tiene todo explicado con dibujos. Hacemos las rutinas en silla juntos 20 minutos por día. Él mejoró el equilibrio y yo me sentí útil por primera vez en el cuidado. Es una conexión que no esperaba.'
  }, {
    initials: 'AM',
    name: 'Andrea M.',
    city: 'CABA',
    desc: 'Hija y organizadora familiar · Adulto mayor 80 años · CABA',
    quote: 'El Kit de Socialización salvó las reuniones familiares de los domingos. Las Cartas de Reminiscencia hicieron que mi papá contara historias de su juventud que nunca habíamos escuchado. Mi hijo de 12 años quedó fascinado. Lloramos de emoción. Es el regalo más valioso que recibimos.'
  }, {
    initials: 'CM',
    name: 'Carolina M.',
    city: 'Santa Fe',
    desc: 'Cuidadora principal · Adulta mayor 76 años · Santa Fe',
    quote: 'La Guía del Cuidador Estrella me salvó el año. Estaba al borde del Burnout cuidando a mi mamá sola. El Test de Agotamiento me mostró que estaba en zona roja. El mapa familiar del cuidado fue la herramienta que usé para hablar con mis hermanos y distribuir las responsabilidades. Hoy cuido con límites y sin culpa.'
  }];
  const data = isInitial ? initialTestimonials : extendedTestimonials;
  return <section className={`py-10 md:py-16 px-4 md:px-6 ${isInitial ? 'bg-familia-bg' : 'bg-familia-card'}`} data-id="element-52">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-53">
        {!isInitial && <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-54">
            Lo que dicen las familias y cuidadores que ya{' '}
            <br className="hidden sm:block" data-id="element-55" /> usan el Vitalidad 360:
          </h2>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-56">
          {data.map((t, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-5 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-57">
              <div className="flex items-center gap-4 mb-4 md:mb-6" data-id="element-58">
                <div className="w-12 h-12 rounded-full bg-familia-cyan text-familia-bg flex items-center justify-center font-bold text-lg shrink-0" data-id="element-59">
                  {t.initials}
                </div>
                <div data-id="element-60">
                  <div className="text-familia-gold text-sm mb-1" data-id="element-61">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <div className="font-bold text-sm" data-id="element-62">{t.name}</div>
                  <div className="text-familia-gray text-[10px] uppercase tracking-wider" data-id="element-63">
                    {t.city}
                  </div>
                </div>
              </div>
              <p className="text-white/90 italic mb-4 md:mb-6 flex-grow leading-relaxed text-[15px]" data-id="element-64">
                "{t.quote}"
              </p>
              <div className="text-xs font-semibold text-familia-cyan/90 pt-4 border-t border-white/10" data-id="element-65">
                {t.desc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};